import React from 'react';
import ReactSound from 'react-sound';
import ear_icon from '../../../images/ear_icon.svg';

export default class ReadAloud extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playStatus: ReactSound.status.STOPPED,
    };
  }

  componentDidMount() {
    if (this.props.audioURL) {
      this.play();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.audioURL && this.props.audioURL) {
      this.play();
    }
    if (prevProps.audioURL != this.props.audioURL) {
      this.play();
    }
  }

  play() {
    this.setState({
      playStatus: ReactSound.status.PLAYING
    });
  }

  onAudioFinished() {
    this.setState({
      playStatus: ReactSound.status.STOPPED
    });
    if (this.props.onAudioFinished) {
      this.props.onAudioFinished()
    }
  }

  render() {
    return (
      <div className="readAloudContainer">
        <img className="readAloudEarIcon" src={ear_icon} alt="" />
        <ReactSound
          url={this.props.audioURL}
          volume={50}
          playStatus={this.state.playStatus}
          onFinishedPlaying={this.onAudioFinished.bind(this)}
        />
      </div>
    );
  }
}
